import { faDiagramNested } from "@fortawesome/pro-regular-svg-icons";
import React from "react";

import {
  SideDrawer,
  useSideDrawerCoordinator,
} from "src/agents/base/SideDrawer";
import { Icon } from "src/base-components/Icon";

type ToolTypeCardProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  dataLoc?: string;
};

const ToolTypeCard: React.FC<ToolTypeCardProps> = ({
  title,
  description,
  icon,
  onClick,
  dataLoc,
}) => {
  return (
    <button
      className="flex flex-1 items-start gap-3 rounded-lg border border-gray-200 bg-white p-2 text-left transition-colors hover:border-gray-300 hover:bg-gray-50"
      data-loc={dataLoc}
      type="button"
      onClick={onClick}
    >
      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-green-electric/40">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-gray-800 font-inter-semibold-13px">{title}</p>
        <p className="text-gray-500 font-inter-normal-12px">{description}</p>
      </div>
    </button>
  );
};

export const AddToolDrawer: React.FC = () => {
  const { openDrawer, requestClose } = useSideDrawerCoordinator();
  const data = openDrawer?.type === "addTool" ? openDrawer.data : undefined;

  const handleAddFlowTool = () => {
    requestClose(); // Close the drawer
    data?.onAddFlowTool(); // Trigger flow selection in parent
  };

  return (
    <SideDrawer
      dataLoc="add-tool-drawer"
      drawerId="addTool"
      header={{
        title: "Add a Tool",
        closeDataLoc: "close-add-tool-drawer",
      }}
    >
      <div className="flex flex-col gap-6 p-5">
        {/* Tool Type Cards */}
        <div className="flex gap-3">
          <ToolTypeCard
            dataLoc="add-flow-tool-card"
            description="Add decision flow as tool"
            icon={
              <Icon color="text-gray-800" icon={faDiagramNested} size="sm" />
            }
            title="Add decision flow"
            onClick={handleAddFlowTool}
          />
        </div>
      </div>
    </SideDrawer>
  );
};
